// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"castle-4"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 9C14.7614 9 17 11.2386 17 14V21H7V14C7 11.2386 9.23858 9 12 9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M21 21V3H15V10C16.2142 10.9122 17 12.3644 17 14V21H21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M3 21H7V14C7 12.3643 7.78565 10.9122 9 10V3H3V21Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 20.9999V18.3428M3 21H7V14C7 12.3643 7.78565 10.9122 9 10V3H3V21ZM21 3V21H17V14C17 12.3644 16.2142 10.9122 15 10V3H21Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M17 14.8V21H7V14.8M12 9C14.7614 9 17 11.2386 17 14H7C7 11.2386 9.23858 9 12 9ZM12 9V8","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-castle-4')
export default class Castle4Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'castle-4',
    }
  }
}
